const tr = {
  // Navigation
  'nav.home': 'Ana Sayfa',
  'nav.about': 'Hakkımızda',
  'nav.directory': 'Destek Alanları',
  'nav.knowledge': 'Rehberimiz',
  'nav.impact': 'Hizmet Alanlarımız',
  'nav.contact': 'İletişim',
  'nav.join': 'Bize Katılın',

  // Hero Section
  'hero.title': 'Hollanda\'da Yeni Bir Başlangıç, Güçlü Bir Gelecek.',
  'hero.subtitle': 'Stichting IPN; yeni gelen bireylerin Hollanda\'daki uyum süreçlerini profesyonel rehberlik, hukuki destek ve Hizmet odaklı bir yaklaşımla kolaylaştıran bir dayanışma merkezidir.',
  'hero.cta.primary': 'Rehberimizi Keşfedin',
  'hero.cta.secondary': 'Daha Fazla Keşfedin',

  // About Section
  'about.title': 'Hollanda\'daki Yeni Yaşamınızda Profesyonel Çözüm Ortağınız',
  'about.subtitle': 'Stichting IPN, Hollanda\'ya yeni gelen bireylerin toplumsal entegrasyon süreçlerini kolaylaştırmak ve karşılaştıkları zorluklara profesyonel çözümler üretmek amacıyla kurulmuş bağımsız bir dayanışma platformudur. İltica süreçlerinden sağlık sistemine erişime, dil eğitiminden (Inburgering) diploma denkliğine kadar her adımda, etik değerlerimiz ve Hizmet odaklı yaklaşımımızla yanınızdayız.',
  'about.mission.title': 'Misyonumuz',
  'about.mission.text': 'Hollanda\'ya yeni gelenlerin karşılaştığı hukuki, sosyal ve kültürel engelleri aşmaları için çalışıyoruz.',
  'about.vision.title': 'Vizyonumuz',
  'about.vision.text': 'Yeni gelen bireylerin Hollanda\'daki uyum süreçlerini profesyonel rehberlik ve Hizmet odaklı yaklaşımla kolaylaştırmak.',
  'about.values.title': 'Değerlerimiz',
  'about.values.text': 'Profesyonel rehberlik, hukuki destek, Hizmet odaklılık ve dayanışma, organizasyonumuzun temel taşlarıdır.',

  // Core Values
  'values.title': 'Temel Değerlerimiz',
  'values.subtitle': 'Çalışmalarımızı Yönlendiren İlkeler',
  'values.ethics.title': 'Profesyonel Rehberlik',
  'values.ethics.text': 'Yeni gelenlerin entegrasyon süreçlerinde uzman rehberlik sunuyoruz',
  'values.wisdom.title': 'Hukuki Destek',
  'values.wisdom.text': 'İltica süreçleri ve oturum hakları konusunda doğrulanmış bilgi sağlıyoruz',
  'values.service.title': 'Hizmet Odaklılık',
  'values.service.text': 'Yeni yaşamınızda sağlam adımlar atmanız için Hizmet odaklı yaklaşım',
  'values.impact.title': 'Dayanışma',
  'values.impact.text': 'Hollanda\'ya yeni gelenleri destekleyerek güçlü bir toplum oluşturuyoruz',

  // Professional Directory
  'directory.title': 'Bilgi Merkezi: Hollanda Yaşam Rehberi',
  'directory.subtitle': 'Hollanda\'daki yeni yaşamınızda ihtiyaç duyacağınız tüm destek hizmetleri',
  'directory.search': 'Destek ara...',
  'directory.filter.all': 'Tüm Alanlar',
  'directory.filter.education': 'Eğitim',
  'directory.filter.healthcare': 'Sağlık',
  'directory.filter.technology': 'Teknoloji',
  'directory.filter.business': 'İş Dünyası',
  'directory.filter.law': 'Hukuk',
  'directory.filter.engineering': 'Mühendislik',
  'directory.viewProfile': 'Detayları Görüntüle',

  // Knowledge Hub
  'knowledge.title': 'Bilgi Merkezi',
  'knowledge.subtitle': 'Stratejik analizler, Hollanda yaşam rehberleri ve toplumsal uyum odaklı içerik merkezi.',
  'knowledge.featured': 'Öne Çıkan Rehberler',
  'knowledge.readMore': 'Devamını Oku',
  'knowledge.viewAll': 'Tüm Rehberleri Görüntüle',

  // Global Impact
  'impact.title': 'Hizmet Alanlarımız',
  'impact.subtitle': 'Hollanda\'ya Yeni Gelenlere Kapsamlı Destek',
  'impact.education.title': 'Hukuki Süreçler ve Haklar',
  'impact.education.text': 'Hollanda\'daki oturum haklarınızdan aile birleşimine kadar tüm yasal süreçlerde doğrulanmış bilgilerle yanınızdayız. İltica prosedürleri ve hukuki danışmanlık rehberimizle adımlarınızı güvenle atın.',
  'impact.healthcare.title': 'Sağlık Sistemi ve Psikososyal Destek',
  'impact.healthcare.text': 'Hollanda sağlık sistemini (Huisarts) anlamak ve psikososyal destek mekanizmalarına erişmek artık daha kolay. Yeni yaşamınıza uyum sağlarken sağlığınızı ve esenliğinizi korumak için gerekli tüm rehberlik burada.',
  'impact.research.title': 'Eğitim, Dil ve Kariyer Yolculuğu',
  'impact.research.text': 'Dil kurslarından (Inburgering) diploma denkliğine, iş arama stratejilerinden kariyer planlamasına kadar profesyonel gelişim yolculuğunuzu destekliyoruz.',
  'impact.humanitarian.title': 'Toplumsal Uyum',
  'impact.humanitarian.text': 'Kültürel uyum ve topluma entegrasyon için Hizmet odaklı projeler',

  // Testimonials
  'testimonials.title': 'Üyelerimizden',
  'testimonials.subtitle': 'Topluluğumuzdan Sesler',

  // Contact
  'contact.title': 'İletişime Geçin',
  'contact.subtitle': 'Sorularınız mı var? Sizden haber almak isteriz',
  'contact.name': 'Adınız',
  'contact.email': 'E-posta Adresiniz',
  'contact.subject': 'Konu',
  'contact.message': 'Mesajınız',
  'contact.send': 'Mesaj Gönder',
  'contact.info.title': 'İletişim Bilgileri',
  'contact.info.address': 'Adres',
  'contact.info.phone': 'Telefon',
  'contact.info.email': 'E-posta',

  // Footer
  'footer.about.title': 'Stichting IPN Hakkında',
  'footer.about.text': 'Yeni gelen bireylerin Hollanda\'daki uyum süreçlerini profesyonel rehberlik, hukuki destek ve Hizmet odaklı bir yaklaşımla kolaylaştıran bir dayanışma merkezi.',
  'footer.quickLinks': 'Hızlı Bağlantılar',
  'footer.connect': 'Bağlantıda Kalın',
  'footer.newsletter': 'Bültenimize Abone Olun',
  'footer.newsletter.placeholder': 'E-posta adresinizi girin',
  'footer.newsletter.button': 'Abone Ol',
  'footer.copyright': '© 2024 Stichting IPN. Tüm hakları saklıdır.',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Hizmet Şartları',

  integration: {
    title: 'Entegrasyon Sürecimiz',
    subtitle: 'Hollanda\'ya gelişinizden vatandaşlığa kadar her adımda yanınızdayız. İşte size rehberlik edeceğimiz 6 aşamalı süreç.',
    step: 'Aşama',
    requiredDocuments: 'Gerekli Belgeler',
    tips: 'Önemli İpuçları',
    getSupport: 'Bu Aşamada Destek Al',
    successTitle: 'Başarı Hikayelerini Keşfedin',
    successDescription: 'Binlerce kişi bu süreci başarıyla tamamladı. Onların deneyimlerinden ilham alın ve siz de başarılı olun.',
    readStories: 'Hikayeleri Okuyun',
    
    steps: {
      step1: {
        shortTitle: 'Varış',
        title: 'Varış & İlk Kayıt',
        description: 'Ter Apel\'de ilk kayıt işlemleri ve geçici barınma düzenlemeleri',
        duration: '1-3 gün',
        documents: [
          'Pasaport veya kimlik belgesi',
          'Seyahat belgeleri',
          'Varsa eğitim ve iş belgeleri',
          'Aile durumunu gösteren belgeler'
        ],
        tips: [
          'Tüm belgelerinizi güvenli bir yerde saklayın',
          'İlk görüşmede dürüst ve açık olun',
          'Tercüman hizmetinden yararlanın',
          'Verilen bilgileri dikkatlice dinleyin'
        ]
      },
      step2: {
        shortTitle: 'Mülakat',
        title: 'IND Mülakatları',
        description: 'İltica başvurusu ve detaylı görüşmeler, hikayenizi anlatma süreci',
        duration: '6-12 ay',
        documents: [
          'Kimlik belgeleri ve fotoğraflar',
          'Ülkenizden ayrılma nedenlerinizi destekleyen belgeler',
          'Varsa tehdit veya zulüm kanıtları',
          'Aile bağlarını gösteren belgeler'
        ],
        tips: [
          'Hikayenizi tutarlı ve detaylı anlatın',
          'Tüm soruları dikkatlice cevaplayın',
          'Avukat desteği alın',
          'Psikolojik destek hizmetlerinden yararlanın'
        ]
      },
      step3: {
        shortTitle: 'Yerleşim',
        title: 'Oturum İzni & Ev Bulma',
        description: 'Oturum izni alımı ve kalıcı konut tahsisi, yeni hayatınızın başlangıcı',
        duration: '2-6 ay',
        documents: [
          'IND kararı ve oturum izni belgesi',
          'BSN (Burgerservicenummer) kaydı',
          'Sağlık sigortası belgesi',
          'Banka hesabı bilgileri'
        ],
        tips: [
          'Belediyeye hemen kayıt olun',
          'Sağlık sigortası yaptırın (zorunlu)',
          'Sosyal yardım başvurusu yapın',
          'Mahalle ve komşularınızla tanışın'
        ]
      },
      step4: {
        shortTitle: 'Eğitim',
        title: 'Dil & Entegrasyon Eğitimi',
        description: 'Hollandaca dil kursu ve toplum entegrasyon programları, kültürel uyum',
        duration: '6-36 ay',
        documents: [
          'Entegrasyon sınavı kayıt belgesi',
          'Dil kursu katılım belgesi',
          'Eğitim ilerleme raporları',
          'Sınav sonuç belgeleri'
        ],
        tips: [
          'Düzenli olarak kurslara katılın',
          'Evde de Hollandaca pratik yapın',
          'Yerel etkinliklere katılın',
          'Gönüllü çalışmalara başvurun'
        ]
      },
      step5: {
        shortTitle: 'İstihdam',
        title: 'İş Bulma & Kariyer',
        description: 'Mesleki eğitim, iş arama desteği ve kariyer planlama hizmetleri',
        duration: '3-12 ay',
        documents: [
          'CV ve motivasyon mektubu',
          'Diploma denklik belgesi',
          'İş başvuru belgeleri',
          'Referans mektupları'
        ],
        tips: [
          'Diplomalarınızı denklendirin',
          'Hollanda tarzı CV hazırlayın',
          'İş ağınızı genişletin (networking)',
          'Staj ve gönüllülük fırsatlarını değerlendirin'
        ]
      },
      step6: {
        shortTitle: 'Vatandaşlık',
        title: 'Vatandaşlık & Sonrası',
        description: 'Hollanda vatandaşlığı başvurusu ve topluma tam entegrasyon',
        duration: '5+ yıl',
        documents: [
          '5 yıllık oturum izni belgesi',
          'Entegrasyon sınavı başarı belgesi',
          'Gelir ve vergi belgeleri',
          'Sabıka kaydı belgesi'
        ],
        tips: [
          'Tüm yasal gereklilikleri yerine getirin',
          'Topluma aktif katılım gösterin',
          'Mali sorumluluklarınızı yerine getirin',
          'Hollanda değerlerini benimseyin'
        ]
      }
    }
  },
  contact: {
    form: {
      name: 'Ad Soyad',
      namePlaceholder: 'Adınızı girin',
      email: 'E-posta',
      emailPlaceholder: 'E-posta adresinizi girin',
      phone: 'Telefon',
      phonePlaceholder: 'Telefon numaranızı girin',
      subject: 'Konu',
      subjectPlaceholder: 'Mesajınızın konusu',
      message: 'Mesaj',
      messagePlaceholder: 'Mesajınızı buraya yazın...',
      maxChars: 'Maksimum 500 karakter',
      submit: 'Mesaj Gönder',
      sending: 'Gönderiliyor...',
      successMessage: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
      errorMessage: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    workingHours: 'Çalışma Saatleri',
    weekdays: 'Hafta İçi',
    weekend: 'Hafta Sonu',
    closed: 'Kapalı',
  },
  news: {
    title: 'Mülteci Haberleri Takip Sistemi',
    subtitle: 'IND, COA, belediyeler ve medyadan mültecilerle ilgili en güncel haberleri takip edin. Aylık bültenimize abone olun ve hiçbir önemli gelişmeyi kaçırmayın.',
    subscribe: 'Aylık Bültene Abone Ol',
    new: 'Yeni',
    readMore: 'Devamını Oku',
    categories: {
      all: 'Tümü',
      municipality: 'Belediyeler',
      media: 'Medya',
      policy: 'Politika',
    },
    items: {
      ind1: {
        title: 'IND Yeni Başvuru Süreçlerini Duyurdu',
        summary: 'IND, sığınma başvurularında yeni prosedürler ve daha hızlı değerlendirme süreçleri getiriyor. Başvuru sahipleri için önemli değişiklikler.',
      },
      coa1: {
        title: 'COA Yeni Kabul Merkezleri Açıyor',
        summary: 'COA, artan talebe yanıt vermek için Hollanda genelinde yeni kabul merkezleri açacağını duyurdu. Kapasitede %30 artış bekleniyor.',
      },
      municipality1: {
        title: 'Amsterdam Entegrasyon Programlarını Genişletiyor',
        source: 'Amsterdam Belediyesi',
        summary: 'Amsterdam Belediyesi, mülteciler için dil kursları ve iş bulma programlarına yatırımı artırıyor. Yeni bütçe onaylandı.',
      },
      media1: {
        title: 'Hollanda\'da Mülteci Entegrasyonu: Başarı Hikayeleri',
        summary: 'NOS, başarılı entegrasyon örneklerini ve mültecilerin Hollanda toplumuna katkılarını anlatan özel bir belgesel yayınladı.',
      },
      policy1: {
        title: 'Yeni Entegrasyon Yasası Mecliste Onaylandı',
        summary: 'Hollanda Meclisi, mültecilerin entegrasyon sürecini kolaylaştıran ve destekleyen yeni yasayı onayladı. Yasa 2024\'te yürürlüğe girecek.',
      },
      ind2: {
        title: 'IND Dijital Başvuru Sistemi Başlatıldı',
        summary: 'IND, sığınma başvurularını dijital olarak yapabilme imkanı sunan yeni platformunu tanıttı. Süreç artık daha hızlı ve şeffaf.',
      },
    },
    infoBox: {
      title: 'Otomatik Haber Takibi',
      description: 'Sistemimiz, IND, COA, Overheid.nl, belediyeler ve önde gelen medya kuruluşlarını günlük olarak tarar ve mültecilerle ilgili önemli haberleri otomatik olarak derler. Aylık bültenimize abone olarak tüm önemli gelişmelerden haberdar olun.',
    },
    modal: {
      title: 'Aylık Bültene Abone Ol',
      description: 'E-posta adresinizi girin ve mültecilerle ilgili en önemli haberleri her ay doğrudan gelen kutunuzda alın.',
      emailLabel: 'E-posta Adresi',
      emailPlaceholder: 'ornek@email.com',
      subscribeButton: 'Abone Ol',
      subscribing: 'Abone Olunuyor...',
      successMessage: 'Başarıyla abone oldunuz! İlk bülteninizi yakında alacaksınız.',
      errorMessage: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
  }
};

export default tr;
